import React from 'react';
import NewPassword from './NewPassword';

function newPassword() {
  return (
    <div className="bg-login-background bg-cover">
      <NewPassword />
    </div>
  );
}

export default newPassword;
